module.exports = __webpack_public_path__ + "img/headerImg-female.97b89416.png";